import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./utilizationStatasticalReport.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import ReactHtmlParser from 'react-html-parser';
import ReactApexChart from "react-apexcharts";
import moment from 'moment';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import { ToastContainer, toast } from 'react-toastify';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import Pagination from 'react-js-pagination';
import { getLibraryAccessDetails, setAssignedInstitute } from 'LIBRARY/Actions/AdminDetailsAction.js';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ReactToPrint from 'react-to-print';
import { connect } from 'react-redux';

class UtilizationStatasticalReport extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isFilter: false,
            isActiveFilter: false,
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            reportDataFetching: false,
            utilizationData: {},
            chartUtilizationData: {},
            activeTab: 'Analytics',
            offset: 0,
            pageIndex: 1,
            limit: 10,

            tableHeaders: [
                "Date",
                "Visitors",
                "E-Library",
                "Daily Issues",
                "Daily Returns"
            ],

            visibleHeaders: [
                "Date",
                "Visitors",
                "E-Library",
                "Daily Issues",
                "Daily Returns"
            ],

            // VARIABLES TO EXPORT EXPENSE
            exportDetails: false,

            // VARIABLES FOR BAR GRAPH
            dateRange: [],
            series: [],

            options: {
                chart: {
                    type: 'bar',
                    height: 350,
                    stacked: true,
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                dataLabels: {
                    formatter: (val) => {
                        return val
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false
                    }
                },
                xaxis: {
                    categories: []
                },
                fill: {
                    opacity: 1
                },
                colors: ['#94EAEA', '#008080', '#79C3FD', '#3789D8', '#DCDCDC', '#B7B7B6', '#95AEEC', '#3764D8'],
                yaxis: {
                    labels: {
                        formatter: (val) => {
                            return val
                        }
                    }
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'left'
                }
            },

            totals: {
                faculty_visitor_count: 0,
                student_visitor_count: 0,
                external_visitor_count: 0,
                faculty_eresource_views: 0,
                student_eresource_views: 0,
                faculty_daily_issues: 0,
                student_daily_issues: 0,
                faculty_daily_returns: 0,
                student_daily_returns: 0,
            },

            facultyVisitorGrandTotal: 0,
            studentVisitorGrandTotal: 0,
            externalVisitorGrandTotal:0,
            facultyEResourceGrandTotal: 0,
            studentEResourceGrandTotal: 0,
            facultyIssuesGrandTotal: 0,
            studentIssuesGrandTotal: 0,
            facultyReturnsGrandTotal: 0,
            studentReturnsGrandTotal: 0
        }
    }

    componentDidMount() {
        // METHOD CALLED TO GET UTILIZATION DATA
        this.getUtilizationStatisticsDataForChart();
        this.getUtilizationStatisticsData();
    }

    // API CALL TO GET ALL UTILIZATION DATA
    getUtilizationStatisticsData = async () => {
        this.setState({
            reportDataFetching: true,
            utilizationData: [],
            totals: {
                faculty_visitor_count: 0,
                student_visitor_count: 0,
                external_visitor_count: 0,
                faculty_eresource_views: 0,
                student_eresource_views: 0,
                faculty_daily_issues: 0,
                student_daily_issues: 0,
                faculty_daily_returns: 0,
                student_daily_returns: 0,
            },
        });

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filterParameter": {
                "startDate": this.state.fromDate,
                "endDate": this.state.toDate
            }

        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryUtilizationStatisticsForReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getUtilizationStatisticsData()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    reportDataFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    utilizationData: apiResult,
                    facultyVisitorGrandTotal: jsonResponse.APIResult.faculty_visitor_GrandCount,
                    studentVisitorGrandTotal: jsonResponse.APIResult.student_visitor_GrandCount,
                    externalVisitorGrandTotal: jsonResponse.APIResult.external_visitor_GrandCount,
                    facultyEResourceGrandTotal: jsonResponse.APIResult.faculty_eresource_views_GrandCount,
                    studentEResourceGrandTotal: jsonResponse.APIResult.student_eresource_views_GrandCount,
                    facultyIssuesGrandTotal: jsonResponse.APIResult.faculty_daily_issues_GrandCount,
                    studentIssuesGrandTotal: jsonResponse.APIResult.student_daily_issues_GrandCount,
                    facultyReturnsGrandTotal: jsonResponse.APIResult.faculty_daily_returns_GrandCount,
                    studentReturnsGrandTotal: jsonResponse.APIResult.student_daily_returns_GrandCount,
                    totalCount: jsonResponse.APIResult.totalDates
                }, () => this.totalCountForReport());
            }
            else {
                this.setState({
                    reportDataFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong. Please try again later.'
                });
            }
        }
    }

    totalCountForReport = () => {
        const totals = {
            faculty_visitor_count: 0,
            student_visitor_count: 0,
            external_visitor_count: 0,
            faculty_eresource_views: 0,
            student_eresource_views: 0,
            faculty_daily_issues: 0,
            student_daily_issues: 0,
            faculty_daily_returns: 0,
            student_daily_returns: 0,
        };

        Object.values(this.state.utilizationData).length > 0 &&
            Object.values(this.state.utilizationData).map((data, index) => {
                totals.faculty_visitor_count += data.faculty_visitor_count || 0;
                totals.student_visitor_count += data.student_visitor_count || 0;
                totals.external_visitor_count += data.external_visitor_count || 0;
                totals.faculty_eresource_views += data.faculty_eresource_views || 0;
                totals.student_eresource_views += data.student_eresource_views || 0;
                totals.faculty_daily_issues += data.faculty_daily_issues || 0;
                totals.student_daily_issues += data.student_daily_issues || 0;
                totals.faculty_daily_returns += data.faculty_daily_returns || 0;
                totals.student_daily_returns += data.student_daily_returns || 0;
            })
        this.setState({ totals });
    }

    // API CALL TO GET UTILIZATION DATA FOR BAR CHART
    getUtilizationStatisticsDataForChart = async () => {
        this.setState({
            reportDataFetching: true,
            chartUtilizationData: []
        });

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": 10,
            "filterParameter": {
                "startDate": this.state.fromDate,
                "endDate": this.state.toDate
            }
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryUtilizationStatisticsForReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getUtilizationStatisticsDataForChart()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                this.setState({
                    reportDataFetching: false
                });
                let apiResult = jsonResponse.APIResult.data;

                this.setState({
                    chartUtilizationData: apiResult,
                }, () => { this.fetchChartData(apiResult) });
            }
            else {
                this.setState({
                    reportDataFetching: false,
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong. Please try again later.'
                });
            }
        }
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET RECEIPTS DETAILS
            this.getUtilizationStatisticsData();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
        }, () => {
            // METHOD CALLED TO GET RECEIPTS DETAILS
            this.getUtilizationStatisticsData();
        });
    }

    // METHOD TO UPDATE CHART RANGE
    updateChartRangeCount = (direction) => {
        const { pageIndex, limit } = this.state;
        let newPageIndex = pageIndex;

        if (direction === 'next') {
            newPageIndex += 1;
        } else if (direction === 'previous' && newPageIndex > 1) {
            newPageIndex -= 1;
        }

        const newOffset = (newPageIndex - 1) * limit;

        this.setState({
            pageIndex: newPageIndex,
            offset: newOffset
        }, () => {
            // Call the method to fetch data for the chart with updated pageIndex and offset
            this.getUtilizationStatisticsDataForChart();
        });
    }

    // CLOSE FILTERS
    closeFilters = () => {
        this.setState({
            isFilter: false,
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
        })
    }

    // VALIDATE APPLY FILTERS
    validateApplyFilters = () => {

        this.setState({
            isActiveFilter: true,
            isFilter: false,
        }, () => {
            this.getUtilizationStatisticsData();
            this.getUtilizationStatisticsDataForChart();
        })
    }

    // FILTER VIEW COMPOENT 
    filterView = () => {
        return (
            <div className="card">
                <div className="card-body">
                    <div className="container-fluid pl-0 pr-0">
                        <div className="row">
                            <div className="pl-0 col-md-12 d-flex pt-2">
                                <div class="mb-3 col-md-4">
                                    <label for="" class="form-label mb-3" style={{ fontSize: 14 }}>From Date<span className="mx-2 text-danger">*</span></label>
                                    <input type="date" class="form-control" style={{ fontSize: 14 }} name="" id="" value={this.state.fromDate} aria-describedby="helpId" placeholder="Select From Date" onChange={(e) => {
                                        this.setState({
                                            fromDate: e.target.value,
                                        })
                                    }} />
                                </div>

                                <div class="mb-3 col-md-4">
                                    <label for="" class="form-label mb-3" style={{ fontSize: 14 }}>To Date<span className="mx-2 text-danger">*</span></label>
                                    <input type="date" class="form-control" style={{ fontSize: 14 }} name="" id="" value={this.state.toDate} aria-describedby="helpId" placeholder="Select To Date" onChange={(e) => {
                                        this.setState({
                                            toDate: e.target.value,
                                        })
                                    }} />
                                </div>
                            </div>
                        </div>

                        <div className="row ">
                            <div className="col d-flex justify-content-end">
                                <button type="button" class="btn btn-primary" onClick={() => {
                                    this.validateApplyFilters()
                                }}>Apply</button>
                                <button type="button" class="btn btn-outline" onClick={() => {
                                    this.setState({
                                        isActiveFilter: false,
                                    }, () => {
                                        this.closeFilters()
                                    })
                                }}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    // METHOD TO SELECT EVENT TYPE
    selectEventType = (type) => {
        if (this.state.activeTab != type) {
            this.setState({
                activeTab: type
            })
        }
    }

    // METHOD TO EXPORT UTILIZATION DATA DETAILS
    exportReportDetails = () => {
        this.setState({
            exportDetails: true
        }, () => {
            document.getElementById('reportExport').click();

            this.setState({
                exportDetails: false
            });
        });
    }

    // UPDATE VISIBILITY OF TABLE COLUMNS
    updateVisibility = (title) => {
        if (this.state.visibleHeaders.includes(title)) {
            this.setState({
                visibleHeaders: [...this.state.visibleHeaders.filter(key => key != title)]
            })
        } else {
            this.setState({
                visibleHeaders: [...this.state.visibleHeaders, title]
            })
        }
    }

    async fetchChartData(result) {

        try {

            const data = await result;
            let dates;
            let seriesData;

            // Extracting dates and series data from the fetched data

            if (Array.isArray(data)) {

                dates = data.map(item => moment(item.date).format("DD/MM/YY"));

                seriesData = [
                    { name: 'Visitors-F', group: 'Visitors', data: data.map(item => item.faculty_visitor_count) },
                    { name: 'Visitors-S', group: 'Visitors', data: data.map(item => item.student_visitor_count) },
                    { name: 'Visitors-E', group: 'Visitors', data: data.map(item => item.external_visitor_count) },
                    { name: 'E-Library-F', group: 'E-Library', data: data.map(item => item.faculty_eresource_views) },
                    { name: 'E-Library-S', group: 'E-Library', data: data.map(item => item.student_eresource_views) },
                    { name: 'Issues-F', group: 'Daily Issues', data: data.map(item => item.faculty_daily_issues) },
                    { name: 'Issues-S', group: 'Daily Issues', data: data.map(item => item.student_daily_issues) },
                    { name: 'Returns-F', group: 'Daily Returns', data: data.map(item => item.faculty_daily_returns) },
                    { name: 'Returns-S', group: 'Daily Returns', data: data.map(item => item.student_daily_returns) }
                ];
            } else {

                dates = Object.values(data).map(item => moment(item.date).format("DD/MM/YY"));

                seriesData = [
                    { name: 'Visitors-F', group: 'Visitors', data: Object.values(data).map(item => item.faculty_visitor_count) },
                    { name: 'Visitors-S', group: 'Visitors', data: Object.values(data).map(item => item.student_visitor_count) },
                    { name: 'Visitors-E', group: 'Visitors', data: Object.values(data).map(item => item.external_visitor_count) },
                    { name: 'E-Library-F', group: 'E-Library', data: Object.values(data).map(item => item.faculty_eresource_views) },
                    { name: 'E-Library-S', group: 'E-Library', data: Object.values(data).map(item => item.student_eresource_views) },
                    { name: 'Issues-F', group: 'Daily Issues', data: Object.values(data).map(item => item.faculty_daily_issues) },
                    { name: 'Issues-S', group: 'Daily Issues', data: Object.values(data).map(item => item.student_daily_issues) },
                    { name: 'Returns-F', group: 'Daily Returns', data: Object.values(data).map(item => item.faculty_daily_returns) },
                    { name: 'Returns-S', group: 'Daily Returns', data: Object.values(data).map(item => item.student_daily_returns) }
                ];
            }

            // Update the state with the fetched data
            this.setState(prevState => ({
                series: seriesData,
                options: {
                    ...prevState.options,
                    xaxis: {
                        ...prevState.options.xaxis,
                        categories: dates
                    }
                },
                dateRange: dates
            }));
        } catch (error) {
            console.error('Error fetching chart data:', error);
        }
    }

    render() {
        const { totals, facultyVisitorGrandTotal, studentVisitorGrandTotal, externalVisitorGrandTotal, facultyEResourceGrandTotal, studentEResourceGrandTotal, facultyIssuesGrandTotal, studentIssuesGrandTotal, facultyReturnsGrandTotal, studentReturnsGrandTotal} = this.state;

        return (
            <div className="pl-3 pr-3" style={{ height: '100%' }}>
                <div style={{ height: '100%' }}>
                    <div className="row justify-content-between mb-1">
                        <div className="col">
                            <div className="report-head-section">
                                <div className="d-flex align-items-center justify-content-between">
                                    <span style={{ cursor: 'pointer' }} onClick={() => {
                                        this.setState({
                                            isFilter: !this.state.isFilter
                                        })
                                    }}>
                                        <FontAwesomeIcon icon={['fas', 'filter']} size={'lg'} />
                                    </span>

                                    <div class="mx-2">
                                        <div style={{ display: 'none' }}>
                                            <ReactHTMLTableToExcel
                                                id="reportExport"
                                                className="btn outline-button waves-effect text-capitalize"
                                                table='utilizationTable'
                                                filename="Library utilization Statistical Report"
                                                sheet="tablexls"
                                                buttonText="Export to Excel"
                                            />
                                        </div>
                                        {
                                            this.state.activeTab == 'Report' && Object.values(this.state.utilizationData).length > 0 &&
                                            <span className="d-flex align-items-center justify-content-between">
                                                <span style={{ border: "1px solid #0465AC", display: "inline-block", padding: "1%", paddingLeft: "5%", paddingRight: "5%", cursor: 'pointer' }} title='Click to export' onClick={() => this.exportReportDetails()} ><FontAwesomeIcon color='#0465AC' icon={['fas', 'file-export']} size={'md'} /></span>
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return <span className='ml-3 mr-3' style={{ border: "1px solid #0465AC", display: "inline-block", padding: "1%", paddingLeft: "5%", paddingRight: "5%", cursor: 'pointer' }} title='Click to print' ><FontAwesomeIcon color='#0465AC' icon={['fas', 'print']} size={'md'} /></span>
                                                    }}
                                                    content={() => this.printReference}
                                                />

                                                <div class="btn-group dropleft">
                                                    <FontAwesomeIcon icon={['fas', 'cog']} size="md" data-toggle="dropdown" title='Customize view utilization report.' style={{ cursor: "pointer" }} />
                                                    <ul class="dropdown-menu">
                                                        <li className="dropdown-item" style={{ cursor: "none" }}>Customize view utilization report.</li>
                                                        <li><hr class="dropdown-divider" /></li>
                                                        {
                                                            this.state.tableHeaders.map((item, index) => {
                                                                return (
                                                                    <li>
                                                                        <a class="dropdown-item" >
                                                                            <div class="form-check form-switch">
                                                                                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" checked={this.state.visibleHeaders.includes(item)} onChange={() => this.updateVisibility(item)} />
                                                                                <label class="form-check-label" for="flexSwitchCheckDefault">{item}</label>
                                                                            </div>
                                                                        </a>

                                                                    </li>
                                                                )
                                                            })
                                                        }
                                                    </ul>
                                                </div>
                                            </span>
                                        }
                                        {
                                            this.state.activeTab == 'Analytics' && Object.values(this.state.chartUtilizationData).length > 0 &&
                                            <span>
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return <span className='pl-2 pr-2' style={{ border: "1px solid #0465AC", display: "inline-block", padding: "1%", paddingLeft: "5%", paddingRight: "5%", cursor: 'pointer' }} title='Click to print' ><FontAwesomeIcon color='#0465AC' icon={['fas', 'print']} size={'md'} /></span>
                                                    }}
                                                    content={() => this.printReference}
                                                />
                                            </span>
                                        }
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    {this.state.isFilter && this.filterView()}

                    <div>
                        <div className="reportRuleLink">
                            <p className={this.state.activeTab == 'Analytics' ? 'reporAactiveTabs reportSettingTab' : 'reportSettingTab'} onClick={() => this.selectEventType('Analytics')}>Analytics</p>
                            <p className={this.state.activeTab == 'Report' ? 'reporAactiveTabs reportSettingTab' : 'reportSettingTab'} onClick={() => this.selectEventType('Report')}>Report</p>
                        </div>
                    </div>

                    {/* {
                        !this.state.isActiveFilter && <p className="alert text-center mt-5 mb-0">Click on <FontAwesomeIcon icon={['fas', 'filter']} size={'md'} /> to apply filter to view report data.</p>
                    } */}

                    {

                        this.state.activeTab == 'Analytics' ?
                            (
                                <div>
                                    <div className='alnalyticNote mt-3 pl-3 pt-1'>
                                        <p style={{ fontSize: '12px', fontWeight: 'bold' }}>Note</p>
                                        <p style={{ fontSize: '12px' }}>Analytics will be drawn on the selected date range in a sequence of Visitors,Daily Issues,Daily Returns and E-Library.</p>
                                    </div>

                                    {this.state.reportDataFetching ?

                                        <div className='pb-5 pt-4'>
                                            <ButtonLoader />
                                        </div>
                                        :
                                        <div className='pt-4'>
                                            <div className='pl-3'>
                                                <span style={{ fontSize: '12px', fontFamily: 'Helvetica' }}>F - Faculty</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <span style={{ fontSize: '12px', fontFamily: 'Helvetica' }}>S - Student</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <span style={{ fontSize: '12px', fontFamily: 'Helvetica' }}>E - External</span>
                                            </div>
                                            <div id="chart" ref={el => this.printReference = el}>
                                                <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={400} />
                                            </div>
                                            <div id="html-dist"></div>
                                        </div>
                                    }
                                    <div className='d-flex justify-content-center pt-3'>
                                        {
                                            this.state.dateRange[0] != moment(this.state.fromDate).format("DD/MM/YY") ?
                                                <span style={{ cursor: 'pointer' }} onClick={() => this.updateChartRangeCount('previous')}>
                                                    <FontAwesomeIcon className='mt-1' icon={['fas', 'arrow-circle-left']} color='#0465AC' size="md" />
                                                    <span className='pl-2' style={{ color: '#0465AC' }}>Previous</span>
                                                </span>
                                                :
                                                <span style={{ cursor: 'not-allowed' }}>
                                                    <FontAwesomeIcon className='mt-1' icon={['fas', 'arrow-circle-left']} color='#81B2D5' size="md" />
                                                    <span className='pl-2' style={{ color: '#81B2D5' }}>Previous</span>
                                                </span>
                                        }&nbsp;&nbsp;
                                        {
                                            this.state.dateRange[0] != undefined && this.state.dateRange[this.state.dateRange.length - 1] != undefined &&
                                            <span className='pt-1 pl-5 pr-5' style={{ fontSize: '14px', color: '#7A7A7A' }}>Date Range
                                                (&nbsp;{this.state.dateRange[0] + ' ' + '-' + ' ' + this.state.dateRange[this.state.dateRange.length - 1]}&nbsp;)</span>
                                        }&nbsp;&nbsp;
                                        {
                                            this.state.dateRange[this.state.dateRange.length - 1] != moment(this.state.toDate).format("DD/MM/YY") ?
                                                <span style={{ cursor: 'pointer' }} onClick={() => this.updateChartRangeCount('next')}>
                                                    <span className='pr-2' style={{ color: '#0465AC' }}>Next</span>
                                                    <FontAwesomeIcon className='mt-1' icon={['fas', 'arrow-circle-right']} color='#0465AC' size="md" />
                                                </span>
                                                :
                                                <span style={{ cursor: 'not-allowed' }}>
                                                    <span className='pr-2' style={{ color: '#81B2D5' }}>Next</span>
                                                    <FontAwesomeIcon className='mt-1' icon={['fas', 'arrow-circle-right']} color='#81B2D5' size="md" />
                                                </span>
                                        }
                                    </div>
                                </div>
                            )
                            :
                            (
                                <>
                                    <div className='pt-4' style={{ height: '100vh' }} ref={el => this.printReference = el}>
                                        <div className='custom-table-container' style={{ paddingLeft: '3%', paddingRight: '3%',  maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' }}>
                                            <div className="college-info" style={{ textAlign: 'center' }}>
                                                <img src={config.instructorInfo.InstituteLogo} style={{ marginBottom: 10, width: 70, height: 70 }} />
                                                <h4 style={{ marginBottom: 10 }}>{ReactHtmlParser(config.instructorInfo.InstituteName)}</h4>
                                                <h5 style={{ fontSize: 18 }}>Library utilization Statistical Report</h5>
                                            </div>
                                            <table className="table table-bordered jumbotron" style={{ background: '#FFF' }} id='utilizationTable'>
                                                <thead className="sticky-header">
                                                    <tr style={{ display: 'none' }}>
                                                        <th colSpan={5}>
                                                            {ReactHtmlParser(config.instructorInfo.InstituteName)}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th className='pb-5' rowSpan="2">Sr. No.</th>
                                                        {this.state.visibleHeaders.includes("Date") && <th className='pb-5' rowSpan="2">Date</th>}
                                                        {this.state.visibleHeaders.includes("Visitors") && <th className='pt-2 pb-2' colspan="4">Visitors</th>}
                                                        {this.state.visibleHeaders.includes("E-Library") && <th className='pt-2 pb-2' colspan="3">E-Library</th>}
                                                        {this.state.visibleHeaders.includes("Daily Issues") && <th className='pt-2 pb-2' colspan="3">Daily Issues</th>}
                                                        {this.state.visibleHeaders.includes("Daily Returns") && <th className='pt-2 pb-2' colspan="3">Daily Returns</th>}
                                                    </tr>
                                                    <tr>
                                                        {this.state.visibleHeaders.includes("Visitors") && <th className='pt-2 pb-2'>Faculty</th>}
                                                        {this.state.visibleHeaders.includes("Visitors") && <th className='pt-2 pb-2'>Student</th>}
                                                        {this.state.visibleHeaders.includes("Visitors") && <th className='pt-2 pb-2'>External</th>}
                                                        {this.state.visibleHeaders.includes("Visitors") && <th className='pt-2 pb-2'>Total</th>}
                                                        {this.state.visibleHeaders.includes("E-Library") && <th className='pt-2 pb-2'>Faculty</th>}
                                                        {this.state.visibleHeaders.includes("E-Library") && <th className='pt-2 pb-2'>Student</th>}
                                                        {this.state.visibleHeaders.includes("E-Library") && <th className='pt-2 pb-2'>Total</th>}
                                                        {this.state.visibleHeaders.includes("Daily Issues") && <th className='pt-2 pb-2'>Faculty</th>}
                                                        {this.state.visibleHeaders.includes("Daily Issues") && <th className='pt-2 pb-2'>Student</th>}
                                                        {this.state.visibleHeaders.includes("Daily Issues") && <th className='pt-2 pb-2'>Total</th>}
                                                        {this.state.visibleHeaders.includes("Daily Returns") && <th className='pt-2 pb-2'>Faculty</th>}
                                                        {this.state.visibleHeaders.includes("Daily Returns") && <th className='pt-2 pb-2'>Student</th>}
                                                        {this.state.visibleHeaders.includes("Daily Returns") && <th className='pt-2 pb-2'>Total</th>}

                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.reportDataFetching ?
                                                            <tr>
                                                                <td colSpan={14}>
                                                                    <ButtonLoader />
                                                                </td>
                                                            </tr>
                                                            :
                                                            Object.values(this.state.utilizationData).length > 0 &&
                                                            Object.values(this.state.utilizationData).map((data, index) => {

                                                                return (
                                                                    <tr key={data.Uniqueid}>
                                                                        <td className='pt-2 pb-2' >{this.state.offset + index + 1}.</td>
                                                                        {this.state.visibleHeaders.includes("Date") && <td className='pt-2 pb-2' >{data.date}</td>}
                                                                        {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2' >{data.faculty_visitor_count}</td>}
                                                                        {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2' >{data.student_visitor_count}</td>}
                                                                        {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2' >{data.external_visitor_count}</td>}
                                                                        {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2' >{data.faculty_visitor_count + data.student_visitor_count + data.external_visitor_count}</td>}
                                                                        {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2' >{data.faculty_eresource_views}</td>}
                                                                        {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2' >{data.student_eresource_views}</td>}
                                                                        {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2' >{data.faculty_eresource_views + data.student_eresource_views}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2' >{data.faculty_daily_issues}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2' >{data.student_daily_issues}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2' >{data.faculty_daily_issues + data.student_daily_issues}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2' >{data.faculty_daily_returns}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2' >{data.student_daily_returns}</td>}
                                                                        {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2' >{data.faculty_daily_returns + data.student_daily_returns}</td>}
                                                                    </tr>
                                                                )
                                                            })
                                                    }
                                                    {
                                                        !this.state.reportDataFetching &&
                                                        <>
                                                            <tr>
                                                                <td className='pt-2 pb-2 fw-600' colSpan={this.state.visibleHeaders.includes("Date") ? 2 : 1}>Total</td>
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_visitor_count}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{totals.student_visitor_count}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{totals.external_visitor_count}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_visitor_count + totals.student_visitor_count + totals.external_visitor_count}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_eresource_views}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{totals.student_eresource_views}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_eresource_views + totals.student_eresource_views}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_daily_issues}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{totals.student_daily_issues}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_daily_issues + totals.student_daily_issues}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_daily_returns}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{totals.student_daily_returns}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{totals.faculty_daily_returns + totals.student_daily_returns}</td>}
                                                            </tr>
                                                            <tr>
                                                                <td className='pt-2 pb-2 fw-600' colSpan={this.state.visibleHeaders.includes("Date") ? 2 : 1}>Grand Total</td>
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{facultyVisitorGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{studentVisitorGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{externalVisitorGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Visitors") && <td className='pt-2 pb-2 fw-600'>{facultyVisitorGrandTotal + studentVisitorGrandTotal + externalVisitorGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{facultyEResourceGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{studentEResourceGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("E-Library") && <td className='pt-2 pb-2 fw-600'>{facultyEResourceGrandTotal + studentEResourceGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{facultyIssuesGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{studentIssuesGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Issues") && <td className='pt-2 pb-2 fw-600'>{facultyIssuesGrandTotal + studentIssuesGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{facultyReturnsGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{studentReturnsGrandTotal}</td>}
                                                                {this.state.visibleHeaders.includes("Daily Returns") && <td className='pt-2 pb-2 fw-600'>{facultyReturnsGrandTotal + studentReturnsGrandTotal}</td>}
                                                            </tr>
                                                        </>
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        {
                                            !this.state.reportDataFetching && !this.state.exportDetails &&
                                            <div className="printHide">
                                                <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                                                    <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                                        <span >Show</span>
                                                        <select
                                                            className="mx-2"
                                                            value={this.state.limit}
                                                            onChange={(e) => this.selectLimit(e)}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={25}>25</option>
                                                            <option value={40}>40</option>
                                                            <option value={100}>100</option>
                                                            <option value={250}>250</option>
                                                        </select>
                                                        <span>entries</span>
                                                    </div>
                                                    <div id="paginationContainer">
                                                        <Pagination
                                                            activePage={this.state.pageIndex}
                                                            itemsCountPerPage={this.state.limit}
                                                            totalItemsCount={this.state.totalCount}
                                                            pageRangeDisplayed={3}
                                                            onChange={(num) => this.updatePaginationCount(num)}
                                                        />
                                                    </div>
                                                    <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalCount} </p>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </>
                            )

                    }

                </div>
            </div>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        assignedInstitute: { ...store.RouteMenuReducer.assignedInstitute },
        assignedIIDArray: { ...store.RouteMenuReducer.assignedIIDArray },
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};


export default connect(mapStateToProps)(UtilizationStatasticalReport);